import React from 'react';
import { Icon } from '../../assets/icons/Icon.jsx';

const TONES = {
  info:       { icon: 'circleInfoFill',          fg: 'var(--primary-normal)',  bg: 'var(--accent-background-light-blue)' },
  positive:   { icon: 'circleCheckFill',         fg: 'var(--status-positive)', bg: 'rgba(0,191,64,0.08)' },
  cautionary: { icon: 'triangleExclamationFill', fg: 'var(--status-cautionary)', bg: 'rgba(255,153,0,0.08)' },
  negative:   { icon: 'circleCloseFill',         fg: 'var(--status-negative)', bg: 'rgba(255,66,66,0.08)' },
};

export function Alert({ tone = 'info', title, children, action, onClose, style }) {
  const t = TONES[tone] || TONES.info;
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: 16,
        borderRadius: 'var(--radius-md)',
        background: t.bg,
        fontFamily: 'var(--font-sans)',
        ...style,
      }}
    >
      <Icon name={t.icon} size={20} style={{ color: t.fg, flex: 'none', marginTop: 1 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && <div style={{ fontSize: 'var(--font-size-label-1)', lineHeight: 'var(--line-height-label-1)', fontWeight: 600, color: 'var(--label-normal)', marginBottom: children ? 2 : 0 }}>{title}</div>}
        {children && <div style={{ fontSize: 'var(--font-size-label-1)', lineHeight: 'var(--line-height-label-1-reading)', color: 'var(--label-alternative)' }}>{children}</div>}
        {action && <div style={{ marginTop: 10 }}>{action}</div>}
      </div>
      {onClose && (
        <button type="button" onClick={onClose} aria-label="닫기" style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', color: 'var(--label-assistive)', flex: 'none' }}>
          <Icon name="close" size={18} />
        </button>
      )}
    </div>
  );
}

export default Alert;
